export const searchImageWithGoogleLens = (imageName: string) => {
  const searchUrl = `https://lens.google.com/uploadbyurl?url=${encodeURIComponent(
    imageName
  )}`;
  window.open(searchUrl, "_blank");
};
